module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/Phone-d60a8f63cfe1981bb672700f4aea20d74f2071cc526ff6d509a3604b1b3f1124.svg";